import Vue from 'vue'
import VueI18n from 'vue-i18n'
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'

Vue.use(VueI18n)
locale.use(lang)

const DEFAULT_LANG = 'en'

const locales = {
  zh: require('./zh.json'),
  en: require('./en.json'),
  polish: require('./polish.json'),
  spanish: require('./spanish.json'),
  turkish: require('./turkish.json'),
  dutch: require('./dutch.json'),
  hungary: require('./hungary.json'),
  zhtw: require('./zh-TW.json'),
  ptbr: require('./pt-BR.json'),
  de: require('./de.json')
}

const i18n = new VueI18n({
  locale: DEFAULT_LANG,
  messages: locales
})

export const setup = lang => {
  if (lang === undefined) {
    lang = location.hash.split('/')[1] || 'en'
    if (locales[lang] === undefined) {
      lang = DEFAULT_LANG
    }
  }
  Vue.config.lang = lang
  i18n.locale = lang
}

setup()
export default i18n



// WEBPACK FOOTER //
// ./src/widgets/i18n/index.js